module.exports = __webpack_public_path__ + "school/img/practice_background.be98645b.png";